<template>
  <iIcon
    v-if="getOptionValue(Icon)"
    :icon="getOptionValue(Icon)"
    :name="getOptionValue(Icon)"
    :variant="getOptionValue(IconVariant)"
    :size="getOptionValue(IconSize)"
    :border-top="myBorderSides.top"
    :border-bottom="myBorderSides.bottom"
    :border-left="myBorderSides.left"
    :border-right="myBorderSides.right"
    disable-hover-effect
    :style-overrides="{
      textShadow: getOptionValue(TextShadow),
      textShadowHover: getOptionValue(TextShadow, BaseOption.$states.HOVER),
      primaryVariantColor: myIconColor,
      secondaryVariantColor: myIconColor,
      errorVariantColor: myIconColor,
      warningVariantColor: myIconColor,
      lightVariantColor: myIconColor,
      brandedVariantColor: myIconColor,
      subtleVariantColor: myIconColor,
    }"
  />
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import Icon from "%/dynamic-components/render-engine/options/icon-options/icon";
import IconVariant from "%/dynamic-components/render-engine/options/icon-options/icon-variant";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import IconSize from "%/dynamic-components/render-engine/options/icon-options/icon-size";
import IconOptions from "%/dynamic-components/render-engine/bundles/icon-options";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import BorderSides from "%/dynamic-components/render-engine/options/border-options/border-sides";
import BorderOptions from "%/dynamic-components/render-engine/bundles/border-options";
import TextShadow from "%/dynamic-components/render-engine/options/text-shadow-options/text-shadow";
import IconColor from "%/dynamic-components/render-engine/options/icon-options/icon-color";

export default {
  name: "Icon",
  mixins: [DynamicElementMixin],
  elementPanelSettings: {
    displayName: "Icon",
    displayIcon: "image",
    elementGroup: "general",
    elementType: "element",
  },
  data() {
    return {
      LayoutHeight,
      LayoutWidth,
      Icon,
      IconVariant,
      IconSize,
      TextShadow,
      BaseOption,
    };
  },
  optionBundles: [
    IconOptions,
    new EffectsOptions({}, {
      "box-shadow": true,
    }),
    BorderOptions,
  ],
  options: [
    new LayoutWidth({
      default: "hug",
    }, true),
    new LayoutHeight({
      default: "hug",
    }, true),
  ],
  computed: {
    myIconColor() {
      const iconOptionValue = this.getOptionValue(IconColor);
      if (!iconOptionValue) {
        return "standard";
      }

      return iconOptionValue;
    },
    myBorderSides() {
      return this.getOptionValue(BorderSides);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
